import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { it, enGB } from 'date-fns/locale';

  const DATE_I18N_OPTIONS = {
    "it": it,
    "en": enGB,
  }

/**
 * Hook personalizzato che gestisce le traduzioni con feature flag.
 * Supporta multiple namespaces.
 * 
 * @param {string|string[]} namespaces - Namespace(s) da utilizzare per le traduzioni
 * @returns {Object} - { t, i18n, isEnabled, locale }
 */
export function useI18n(namespaces = 'common') {
  const { t: i18nT, i18n } = useTranslation(namespaces);
  
  const isEnabled = useSelector((state) => state.features.i18nEnabled);

  const locale = isEnabled ? DATE_I18N_OPTIONS[i18n.language] : it;

  const t = useCallback((key, options = {}) => {
    if (!isEnabled) {
      // Se i18n è disabilitato, ritorna il defaultValue o la chiave stessa
      return options.defaultValue || key;
    }
    return i18nT(key, options);
  }, [i18nT, isEnabled]);

  return {
    t,
    i18n,
    isEnabled,
    locale
  };
}